module.exports = __webpack_public_path__ + "img/ilustracion_no_documentos__Artboard.a420343f.png";